import * as React from "react";

import { nullElement } from "../../../../TypingUtils";

import { IsFilledContext } from "./IsFilledContext";

interface PageFilledConditionalProps {
    visibleIfFilled: boolean;
    children: React.ReactNode;
}

export function PageFilledConditional(props: PageFilledConditionalProps): JSX.Element | null {
    return (
        <IsFilledContext.Consumer>
            {isFilled =>
                (props.visibleIfFilled && isFilled) || (!props.visibleIfFilled && !isFilled)
                    ? props.children
                    : nullElement
            }
        </IsFilledContext.Consumer>
    );
}
